(function() {
	'use strict';

	angular
		.module('pwc.controllers')
		.controller('WineSubtractDialogController', WineSubtractDialogController);

	WineSubtractDialogController.$inject = ['$mdDialog', 'wine', 'DialogService', 'persistOnSave'];

	/**
	 * Responsible to providing a dialog for walking the user through what type of *new* subtraction item they want to record.
	 *
	 * @param $mdDialog
	 * @param wine
	 * @param DialogService
	 * @param persistOnSave
	 * @constructor
	 */
	function WineSubtractDialogController($mdDialog, wine, DialogService, persistOnSave){

		/* jshint validthis: true */
		var self = this;

		self.wine = wine;

		self.gift = gift;
		self.loss = loss;
		self.drink = drink;
		self.sale = sale;
		self.closeDialog = closeDialog;

		function closeDialog(){
			return $mdDialog.hide();
		}

		function gift(){
			closeDialog().then(function(){

				if (self.wine.cellar.qty > 0){
					return DialogService.gift(self.wine, null, null, persistOnSave);
				}

				return showAlert('You do not have any bottles to sell!');
			});
		}

		function loss(){
			closeDialog().then(function(){

				if (self.wine.cellar.qty > 0){
					return DialogService.loss(self.wine, null, null, persistOnSave);
				}

				return showAlert('You do not have any bottles to sell!');
			});
		}

		function sale(){

			closeDialog().then(function(){

				if (self.wine.cellar.qty > 0){
					return DialogService.sale(self.wine, null, null, persistOnSave);
				}

				return showAlert('You do not have any bottles to sell!');
			});
		}

		function drink(){

			closeDialog().then(function() {
				if (self.wine.cellar.qty > 0) {
					return DialogService.drink(self.wine, null, null, persistOnSave);
				}

				return showAlert('You do not have any bottles to drink!');
			});
		}

		function showAlert(content) {
			return $mdDialog.show(
				$mdDialog.alert({
					"title": "Oops",
					"content": content,
					"ok": "Got it!"
				})
			);
		}
	}

})();
